<template>

    <NotificationsSettingsWidget
        :days="days"
    />

    <NotificationsVacationWidget
        :vacations="vacations"
    />

</template>

<script>
import {defineComponent} from "vue";
import AppLayout from "../Layouts/AppLayout";
import NotificationsSettingsWidget from "../Widgets/NotificationsSettingsWidget";
import NotificationsVacationWidget from "../Widgets/NotificationsVacationWidget";

export default defineComponent({

    components: {
        NotificationsVacationWidget,
        NotificationsSettingsWidget
    },


    layout: AppLayout,


    props: {
        days : {
            type: Array,
        },
        vacations: {
            type: Array,
        }
    },

});
</script>

<style scoped>

</style>
